<template>
		<div class="home-page">
		<Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png"  class="nav-icon-left" />
        <div>{{$t('Back')}}</div>
      </div>
    </div>
      <div class="mission-content ac crfff">
        <div class="fs50 mt50">{{$t('aiAnimeTitle')}}</div>
        <div class="css-1asaykn mt50">
          <div class="css-12nj5ib mt30">
            <div style="">{{$t('sexContent1')}}</div>
          </div>
          <div class="css-12nj5ib mt30">
            <div style="">{{$t('sexContent2')}}</div>
          </div>
            <!-- <div class="quan table mt50">
              <span @click="getSex" :class="{'active':isSex}"><img width="20" src="../../static/images/nan.png" />{{$t('Female')}}</span>
              <span @click="getSex" :class="{'active':!isSex}"><img width="26" src="../../static/images/nv.png" />{{$t('Male')}}</span>
            </div> -->
          <div id="controlBox" class="oneImageInput mt50">
            <div class="oneImageInput-content">
              <input type="file" @change="convertToBase64" class="file" accept=".jpg, .jpeg, .png, .webp">
              <div class="imageInputBox">
                <div class="uploadBox uploadIcon">
                  <img style="width:80%;" v-if="imageBase64" :src="imageBase64" />
                  <div class="" v-else>
                    <img width="40" src="../../static/images/transparent.png">
                    <div class="label"> {{$t('Upload')}} </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ul hair-ul" v-if="isSex">
            <div class="li" :class="{'active':isType==item.key}" v-for="(item,index) in sexList" @click="getClick(item)">
              <img v-if="isType==item.key" class="dui" src="../../static/images/dui.png">
              <img class="img" :src="'../../static/images/'+item.key+'.jpg'" />
              <div class="name">{{$t(item.title)}}</div>
            </div>
          </div>
          <div class="ul hair-ul" v-else>
            <div class="li" :class="{'active':isType==item.key}" v-for="(item,index) in boyList" @click="getClick(item)">
              <img v-if="isType==item.key" class="dui" src="../../static/images/dui.png">
              <img class="img" :src="'../../static/images/nan'+(index+1)+'.png'" />
              <div class="name">{{$t(item.title)}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ac mt30">
          <button style="width: calc(100% - 100px);" @click="uploadImage" class="button"><strong>{{$t('Generate')}}</strong></button>
      </div>
      <div class="flex mt50" style="justify-content: space-around;width: 94%;margin: 0 auto;">
        <button class="btn btn-blue">{{$t('ChancesLeft')}} : {{score}}</button>
<!--        <button class="button fs12 ml10" @click="goPurchaseChances"><strong>{{$t('BuyChances')}}</strong><img style="margin-left: 0.1rem;" width="15" src="../../static/images/buy.png"></button>-->
      </div>
      <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
          <div class="alert-modal" slot="mdBox" >
              <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 50px;">×</div>
              <div class="image ac" v-if="imageShow">
                <div class="" style="font-size:0.3rem;margin-bottom: 20px;">{{$t('downTips1')}}</div>
               <img :src="detail.url" style="width:80%;" />
                <div class="img-tools">
                  <div class="ac mt20">
                    <div class="input-item mt50" style="margin-bottom: 20px;">
                      <div class="input-item2">
                        <input class="input" v-model="detail.url" disabled type="" placeholder="">
                      </div>
                    </div>
                    <button class="button fw7" style="width: 100%;" id="copycode" :data-clipboard-text="detail.url" v-if="detail.url" @click="copy(detail.url)">{{$t('copyLink')}}<img style="margin-left: 10px;width: 1rem" src="../../static/images/copy1.png" /></button>
                  </div>
                </div>
              </div>
          </div>
      </Dialog>
		</div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {

    return {
			detail:{},
			isShow:false,
			value:50,
			imageShow:false,
			imageBase64: null,
			imageTpye:'',
			withScratch:false,
			isImgModel:false,
			isImage:true,
      score:0,
      isType:'',
      isModel:'',
      isSex:true,
      sexList:[
        {'title':'HKcatoon','key':'hkcartoon','model':'hanfu-v1_1.0'},
        {'title':'JPcartoon','key':'jpcartoon','model':'9d32a02fa05e2f4e15ec25c1f2fda1fe_1.0'},
        {'title':'TC cartoon','key':'tccartoon','model':'b61f370eaf0dad5217e1c38f45a738f3_1.0'},
        {'title':'Anime','key':'anime','model':'50db365b4a55e545359fa1f5dc707912_1.0'}
        ],
        boyList:[
          {'title':'Style1','key':'style4'},
          {'title':'Style2','key':'style5'},
          {'title':'Style3','key':'style6'},
          {'title':'Comic','key':'us_comic_boy'},
          {'title':'Disney','key':'disney_boy'},
          {'title':'Ghibli','key':'Ghibli_boy'},
        ]
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
  methods: {
    copy(item){
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    getLink(url){
      let link = document.createElement('a');
      link.href =url;// 图片的 URL
      link.download='';// 可选，可以设置文件名
      link.click();// 模拟点击下载
    },
    getSex(){
      this.isSex = !this.isSex
      this.isType = ''
    },
    getClick(item){
      this.isType = item.key
      this.isModel = item.model
    },
		back(){
			this.$router.push({path:'/'})
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.get('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
          that.score=r.data.score
        });
			})
		},
    getCharactersAfter(str, charToFind) {
      var index = str.indexOf(charToFind);
      if (index !== -1) {
        return str.slice(index + 1);
      }
      return ''; // 如果字符未找到，返回空字符串
    },
    convertToBase64(event) {
      const file = event.target.files[0];
      this.imageTpye = this.getCharactersAfter(file.type, '/');
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageBase64 = e.target.result;
          // 在这里可以将Base64字符串上传到服务器
         // this.uploadImage(this.imageBase64);
        };
        reader.readAsDataURL(file);
      }
    },
    uploadImage() {
      let that = this
      if(!that.isType){
        that.$utils.alertText(that.$t('sexTitle2'),100);
        return;
      }else if(!that.imageBase64){
        that.$utils.alertText(that.$t('uploadTips'),100);
        return;
      }
      let data ={
        image:{
          type:that.imageTpye,
          content:that.imageBase64
        },
        style:that.isType,
        model:that.isModel
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/index/cartoon_yourself',data,r =>{
        if(r.code==0){
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg,100);
          return;
        }
      	that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          that.getHome()
          that.$refs.imgDialog.showMaskFun();
          that.imageShow = true
          that.detail = r.data
      	});
      })
    },
    getImage(){
       const link = document.createElement('a')
       link.style.display = 'none'
       link.href = this.detail.url
       console.log(link.href)
       // link.target = '_blank'
       link.setAttribute('download', '文件名称')
       document.body.appendChild(link)
       link.click()
        window.open(this.detail.url, '_blank')

    },
    closeTmgDialog(){
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    goPurchaseChances(){
      this.$router.push({path:'/purchaseChances'})
    }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/cartoonYourself.vue